import { UserManager, WebStorageStateStore, UserManagerSettings } from 'oidc-client';
import { User } from 'shared/models/site/user';
import appSettings from 'shared/settings/appSettings';
import { userMapper } from 'overrides/mapping/user-mapping'

const config = {
    authority: appSettings.identityServer,
    client_id: "portalWeb",
    redirect_uri: `${ appSettings.api.webSite }/signin-oidc`,
    response_type: "code",
    scope: "openid profile roles",
    post_logout_redirect_uri: `${ appSettings.api.webSite }/signout-oidc`,
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: `${ appSettings.api.webSite }/silent-auth`,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: window.localStorage })
};

// this will proxy the methods on the underlying platform's OIDC implementation, giving access to a standard user model
// proxy additional methods as needed by implement them in the mobile app too



class UserManagerProxy {
    private userManager: UserManager;
    readonly accessTokenExpiringNotificationTime: number;

    constructor(settings: UserManagerSettings) {
        this.userManager = new UserManager(settings)
        this.accessTokenExpiringNotificationTime = this.userManager?.settings?.accessTokenExpiringNotificationTime as number;
    }

    getUser = async (): Promise<User | null> => {
        const oidcUser = await this.userManager.getUser();
        if (oidcUser) {
            return userMapper.mapFromOIDCUser(oidcUser);
        }
        return null;

    }

    signinRedirectCallback = async (): Promise<User | null> => {
        const oidcUser = await this.userManager.signinRedirectCallback();
        if (oidcUser) {
            return userMapper.mapFromOIDCUser(oidcUser);
        }
        return null;
    }

    signinSilent = async (): Promise<User | null> => {
        const oidcUser = await this.userManager.signinSilent();
        if (oidcUser) {
            return userMapper.mapFromOIDCUser(oidcUser);
        }
        return null;
    }

    clearStaleState = () => this.userManager.clearStaleState();
    removeUser = () => this.userManager.removeUser();
    signoutRedirect = () => this.userManager.signoutRedirect();
    signinRedirect = () => this.userManager.signinRedirect();
    signoutRedirectCallback = () => this.userManager.signoutRedirectCallback();
    signinSilentCallback = () => this.userManager.signinSilentCallback();

    getProxiedObject = () => this.userManager;
}

export default new UserManagerProxy(config);




